module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/kind_icons/new_survivor-f8fd3f76d0ca55db9b19fb955c51ef57.svg";